import styled from "styled-components";
import { ids } from "@icarros/theme-react";
const { size } = ids || {};
export const ModalHeaderContainer = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  > div {
    max-width: calc(100% - 46px);
    overflow: hidden;
    overflow-wrap: anywhere;
  }
  > button {
    margin-left: auto;
    margin-right: -${size.general.ids_size_general_8x};
  }
`;
//# sourceMappingURL=ModalHeader.style.js.map